<template>
    <modal
        :title="$t(title)"
        :id="id"
        :actionButtons="true"
        :deleteAction="data._id ? data.can_delete ? deleteItem : false : false"
        :saveAction="save"
        size="lg"
        :closeButton="false"
        @shown="shown"
    >
        <template slot="modal-header">
            <span></span>
        </template>
        <div class="row" style="height:75vh; overflow-y:auto">
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label>{{$t('Date')}}</label>
                    <date-picker v-model="data.xrayAt"></date-picker>
                </div>
            </div>

            <div class="col-6 col-md-6">
                <div class="form-group">
                    <label>{{$t('Type')}}</label>
                    <b-form-select v-model="data.type">
                        <option
                            v-for="(type, typeIdx) in xrayTypes"
                            :key="typeIdx"
                            :value="type.value"
                        >{{ $t(type.label)}}</option>
                    </b-form-select>
                </div>
            </div>
            <div class="col-4 col-md-4">
                <div class="form-group">
                    <label>{{$t('Tooth #' )}}</label>
                    <b-form-input v-model.trim="data.tooth" type="text"></b-form-input>
                </div>
            </div>
            <div class="col-4 col-md-4">
                <div class="form-group">
                    <label>{{$t('Quantity')}}</label>
                    <b-form-input v-model="data.quantity" type="text"></b-form-input>
                </div>
            </div>
            <div class="col-4 col-md-4">
                <div class="form-group">
                    <label>{{$t('Dose')}}</label>
                    <b-input-group :append="$t('mSv')">
                        <b-form-input v-model.trim="data.dose" type="text"></b-form-input>
                    </b-input-group>
                </div>
            </div>

            <!-- <div class="col-6 col-md-6">
                <div class="form-group">
                    <label>{{$t('Label')}}</label>
                    <b-form-input v-model.trim="data.label" type="text"></b-form-input>
                </div>
            </div>-->
            <div class="col-12 col-md-12">
                <div class="form-group">
                    <label>{{$t('Conclusion')}}</label>
                    <b-form-textarea v-model.trim="data.notes"></b-form-textarea>
                </div>
            </div>
            <div class="col-12">
                <uploader type="application/pdf,.doc,.zip,image/*" :afterUpload="addImagesToList" :params="fileData"></uploader>
                <ul class="list-group list-group-lg list-group-flush list my-n4">
                    <li class="list-group-item px-0" v-for="(image, index) in images" :key="index">
                        <div class="row align-items-center">
                            <div class="col-auto">
                                <file-preview :src="image.url" :mimetype="image.mimetype" type="rounded"></file-preview>
                            </div>
                            <div class="col ml-n2">
                                <h4 class="card-title mb-1 name">{{ image.label }}</h4>
                                <p
                                    class="card-text small text-muted mb-1"
                                >{{ image.size | PrettyBytes }}, {{ image.mimetype }}</p>
                                <p class="card-text small text-muted">
                                    <avatar
                                        type="circle"
                                        v-if="image.user"
                                        :src="image.user.avatar.preview"
                                        size="avatar-xs"
                                    ></avatar>
                                    <span
                                        v-for="(tag, tagIndex) in image.tags"
                                        :key="tagIndex"
                                        class="badge badge-soft-info ml-1"
                                    >{{ tag }}</span>
                                </p>
                            </div>
                            <div class="col-auto">
                                <p class="card-text small text-muted">{{ image.createdAt | moment("calendar") }}</p>
                            </div>
                            <div class="col-auto">
                                <button
                                    class="btn btn-white ml-2"
                                    @click="openModal({id:'mediaViewModal', model:image})"
                                >
                                    <i class="fe fe-eye"></i>
                                </button>

                                <confirmable-button
                                    style="display:inline-block"
                                    v-b-tooltip
                                    :title="$t('Remove')"
                                    class="ml-2"
                                    @confirm="removeMedia(image._id)"
                                >
                                    <i class="fe fe-trash text-danger"></i>
                                </confirmable-button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <media-view-modal id="mediaViewModal" :item="model"></media-view-modal>
    </modal>
</template>

<script>



import { mapActions, mapGetters, mapState } from 'vuex';
import { modalMixins } from '@/mixins/modal.js'

import Modal from "@/components/Modal";
import Avatar from '@/components/Avatar'
import DatePicker from '@/components/DatePicker';
import Uploader from '@/components/Uploader';
import PrettyBytes from '@/filters/pretty-bytes.ts';
import FilePreview from '@/components/FilePreview'
import MediaViewModal from '@/components/MediaViewModal'
import { xrayTypes, doses } from '@/filters/xrays.js';
import ConfirmableButton from '@/components/ConfirmableButton';

export default {
    name: 'xray-modal',
    props: ['id', 'xray'],
    mixins: [modalMixins],
    filters: { PrettyBytes },
    components: {
        Modal,
        Avatar,
        Uploader,
        DatePicker,
        FilePreview,
        MediaViewModal,
        ConfirmableButton
    },
    data() {
        return {
            loading: false,
            hideForm: false,
            data: {
                quantity: 1,
            },


            params: {
                query: {
                    $limit: 100,
                    customerId: this.$route.params.id,
                    category: 'xrays',
                    $sort: {
                        createdAt: -1
                    }
                }
            },
            fileData: {
                customerId: this.$route.params.id,
                tags: ['Storage'],
                category: 'xrays'

            },
            title: 'Xray',
        }
    },
    watch: {
        'data.type'(type) {
            this.$set(this.data, 'dose', this.doses[type]);
        },
        images1(newValue) {

            // if (newValue.length == 0) return;
            this.data.attachments = [];
            newValue.forEach(item => {
                this.data.attachments.push(item._id);
            })
        }

    },
    computed: {
        ...mapState('media', { areFilesLoading: 'isFindPending' }),
        ...mapGetters('media', {
            findMediaInStore: 'find'
        }),
        ...mapGetters('users', {
            user: 'get'
        }),
        images: {
            get() {

                let images = this.findMediaInStore(this.params).data;
                images.map(image => {
                    image.user = this.user(image.userId);

                });

                return images;
            },
            set(value) {
                this.images.push(value);
            }

        },
        customerId() {
            return this.$parent.customer._id;
        },
        xrayTypes() {
            return xrayTypes;
        },
        doses() {
            return doses;
        }

    },
    methods: {
        ...mapActions('xrays', ['create', 'patch', 'remove']),
        ...mapActions('media', { 'findMedia': 'find', 'removeMedia': 'remove', 'createMedia': 'create' }),

        removeMediaAction(item) {
            //console.log(';item', item);

            // this.removeMedia();
        },

        change() {

        },
        deleteItem() {
            this.remove(this.data._id).then(result => {
                this.$toasted.global.success({
                    message: this.$t('Item has been deleted')
                });
            });
        },
        shown() {
            this.data = JSON.parse(JSON.stringify(this.xray));

            if (!this.data._id) {
                this.data.xrayAt = this.$moment().subtract('1', 'day').format('YYYY-MM-DD');
            }

            if (!this.data.attachments) {
                this.data.attachments = [];
            }
            this.params.query._id = { $in: this.data.attachments };

            this.fetchMedia().then(result => {

                result.data.forEach(item => {
                    //console.log('item', item);
                })

            });
        },
        save() {
            this.errors = null;
            let promise, successMessage;

            if (this.data._id) {
                promise = this.patch([this.data._id, this.data, {}]);
                successMessage = 'Record updated';
            } else {
                promise = this.create(this.data);
                successMessage = 'Record created';
            }

            promise.then(data => {
                this.$root.$emit('bv::hide::modal', this.id);
                this.$toasted.global.success({
                    message: successMessage
                });
                this.data = {};

            }).catch(errors => {
                this.errors = errors.errors;
            })


        },
        fetchMedia() {
            //console.log('this::params::::', this.params);

            return this.findMedia(this.params);
        },
        addImagesToList(file, message) {
            this.data.attachments.push(message.file._id);
        }

    },

}
</script>
